// extracted by mini-css-extract-plugin
module.exports = {"dropdownMenu":"DropdownMenu_dropdownMenu__c__P6","hidden":"DropdownMenu_hidden__N38Zu","menuList":"DropdownMenu_menuList__0nDDq","menuItem":"DropdownMenu_menuItem__1y0Ab"};